import type { FormattedToastMessage } from '~/util/formatToastMessage';
import type { ActionType } from '../../constants';
import type { SetterOrUpdater } from 'recoil';
import formatToastMessage from '~/util/formatToastMessage';
import Catalog from '~/Catalog';
import { reporter } from '~/hooks/useErrorReporter';

const text = {
  deactivate: 'deactiveren',
  activate: 'activeren',
  delete: 'verwijderen',
};

type Args = {
  selectedItems: Array<string>;
  actionType: ActionType;
  setIsLoading: SetterOrUpdater<boolean>;
  addToast: SetterOrUpdater<Array<FormattedToastMessage>>;
  mutationFn: (id: string) => Promise<any>;
  onClose: () => void;
  getText: (count: number) => string;
};

const executeBatchMutation = async ({
  selectedItems,
  actionType,
  mutationFn,
  onClose,
  setIsLoading,
  addToast,
  getText,
}: Args) => {
  setIsLoading(true);

  try {
    const promises = selectedItems.map(id => mutationFn(id));
    const results = await Promise.allSettled(promises);

    const successfulAmount = results.filter(
      result =>
        result.status === 'fulfilled' &&
        result.value?.data &&
        (!result.value.errors || result.value.errors.length === 0),
    )?.length;

    const failedAmount = results.filter(
      result =>
        result.status === 'rejected' ||
        (result.status === 'fulfilled' &&
          result.value?.errors &&
          result.value.errors.length > 0),
    )?.length;

    if (failedAmount === 0) {
      // All succeeded
      addToast([
        formatToastMessage(
          `Succesvol ${text[actionType]} ${successfulAmount} ${getText(successfulAmount)}`,
          'success',
        ),
      ]);
    } else if (successfulAmount === 0) {
      // All failed
      addToast([
        formatToastMessage(
          `Mislukt om ${text[actionType]} ${failedAmount} ${getText(failedAmount)}`,
          'danger',
        ),
      ]);
    } else {
      // Mixed results
      addToast([
        formatToastMessage(
          `Succesvol ${text[actionType]} ${successfulAmount} ${getText(successfulAmount)}, mislukt om ${text[actionType]} ${failedAmount} ${getText(failedAmount)}`,
          'warning',
        ),
      ]);
    }
  } catch (error) {
    reporter.captureException(error, 'error');
    addToast([
      formatToastMessage(Catalog.genericUnknownErrorMessage, 'danger'),
    ]);
  } finally {
    setIsLoading(false);
    onClose();
  }
};

export default executeBatchMutation;
